
const AppLayout = (props: any) => {
  const isHasBottom = Array.isArray(props?.children)
    ? props?.children
        ?.map((e: any) => e?.type?.type?.displayName)
        .includes("BottomNavigation")
    : false;

  return (
    <>
        <div
          className={
            `min-h-screen ${isHasBottom ? "pb-[70px]" : ""}` +
            (props.className || "")
          }
        >
          {props.children}
        </div>
    </>
  );
};

export default AppLayout;
